import React from "react";

import { Table, TableRow, TableBody } from "@material-ui/core";
import { AssigneeProblems } from "../../../generated/graphql";
import { CustomTable } from "../../shared/CustomTable";
import { ColorizedTableCell, CustomTableHead, CustomTableHeaderCell, CustomTableCell } from "../../shared/CustomTable/CustomTable.style";

interface IAssigneeProps {
  tasks: AssigneeProblems[]
}

const headers = [
  'Ключ задачи',
  'Название',
  'Jira Id ответственного'
]

export const Assignee = ({ tasks }: IAssigneeProps) => {
  const content = (
    <Table>
      <CustomTableHead>
        <TableRow>
          {headers.map(header => (
            <CustomTableHeaderCell
              key={header}
              width={50}
            >
              {header}
            </CustomTableHeaderCell>
          ))}
        </TableRow>
      </CustomTableHead>

      <TableBody>
        {tasks.length
          ? (tasks.map(task => (
            <TableRow
              key={task.key}
            >
              {[task.key, task.name, task.assigneeJiraId].map((field, i) => (
                <ColorizedTableCell
                  key={`${i} ${field}`}
                  number={field ? 0 : -1 }
                >
                  {field}
                </ColorizedTableCell>
              ))}
            </TableRow>
          )))
          : (
            <TableRow>
              <CustomTableCell colSpan={3} >Задачи отсутствуют</CustomTableCell>
            </TableRow>
          )
        }
      </TableBody>
    </Table>
  )

  return (
    <CustomTable data={tasks} tableContent={content} />
  )
}